import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function getSearchedInterventionFailure(draft: Draft<IInterventionData>) {
  draft.getSearchedIntervention.config.isLoading = false;
}

export default getSearchedInterventionFailure;
